import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import localeEsMxExtra from '@angular/common/locales/extra/es-MX';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Registrar el locale es-MX, el único que usa la aplicación (ver LOCALE_ID en app.config.ts)
registerLocaleData(localeEsMx, 'es-MX', localeEsMxExtra);

/**
 * Normaliza deep links públicos del visor para hacerlos compatibles con hash routing.
 * Si el navegador entra por `/viewer/document/:uuid` sin hash, reescribe la URL a
 * `/#/viewer/document/:uuid` antes de que Angular inicialice el router.
 */
function normalizePublicViewerUrl(): void {
  const { hash, pathname, search } = globalThis.location;
  const isViewerDocumentPath = /^\/viewer\/document\/[^/]+/.test(pathname);

  if (hash || !isViewerDocumentPath) {
    return;
  }

  globalThis.history.replaceState(
    null,
    document.title,
    `/#${pathname}${search}`,
  );
}

normalizePublicViewerUrl();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
